module.exports = __webpack_public_path__ + "img/course_0010.cb40ff5.png";